/**
 * 获取浏览器的信息
 */
class BrowserInfo {
    constructor() {}
    /**
     * 返回浏览器的信息
     */
    get() {
        let userAgent = navigator.userAgent.toLowerCase();
        let _version,
            _browserVersion,
            browser = {};

        try {
            _browserVersion = userAgent.match(/(?:firefox|opera|safari|chrome|msie|micromessenger)[\/: ]([\d.]+)/);
            if (_browserVersion) {
                _browserVersion = _browserVersion[1];
            } else {
                _browserVersion = '0';
            }

            /* 获得浏览器的名称及版本信息 */
            browser = {
                version: _browserVersion,
                safari: /version.+safari/.test(userAgent) || /safari[\/ ]+([\d.]+)/.test(userAgent),
                chrome: /chrome|crios|crmo/.test(userAgent),
                firefox: /firefox/.test(userAgent),
                ie: /msie/.test(userAgent) || /trident/.test(userAgent), // IE
                edge: /edge/.test(userAgent),
                opera: /opera/.test(userAgent), // opera
                uc: /ucbrowser\/([\d.]+)/.test(userAgent),
                au: /mxbrowser/i.test(userAgent) || /mxios/i.test(userAgent), // 遨游浏览器
                lb: /liebaofast/.test(userAgent), // 猎豹浏览器
                qq: /mqqbrowser/.test(userAgent), // qq浏览器器
                sg: /se 2.+x/.test(userAgent) || /sogou/.test(userAgent), // 搜狗浏览器
                wx: /micromessenger/i.test(userAgent), // 微信
                batapp: /baiduboxapp/.test(userAgent), // 手机百度
                bat: /baidubrowser/.test(userAgent), // 百度浏览器
            };

            _version = browser.version.split('.')[0];

            if (browser.uc) {
                _version = userAgent.match(/ucbrowser\/([\d.]+)/)
                    ? userAgent.match(/ucbrowser\/([\d.]+)/)[1]
                    : _version;
                // return 'UC_' + _version;
                return true;
            }

            if (browser.au) {
                if (userAgent.match(/mxbrowser\/([\d.]+)/)) {
                    // android
                    _version = userAgent.match(/mxbrowser\/([\d.]+)/)[1];
                } else if (userAgent.match(/mxios\/([\d.]+)/)) {
                    //ios
                    _version = userAgent.match(/mxios\/([\d.]+)/)[1];
                } else {
                    _version = _version;
                }

                // return 'AU_' + _version;
                return true;
            }

            if (browser.lb) {
                _version = userAgent.match(/liebaofast\/([0-9.]+)/)
                    ? userAgent.match(/liebaofast\/([0-9.]+)/)[1]
                    : _version;
                // return 'LB_' + _version;
                return true;
            }

            // if (browser.mqq) {
            //     _version = userAgent.match(/qq\/([\d.]+)/) ? userAgent.match(/qq\/([\d.]+)/)[1] : _version;
            //     return 'MQQ_' + _version;
            // }

            if (browser.qq && !browser.wx) {
                _version = userAgent.match(/qqbrowser\/([\d.]+)/)
                    ? userAgent.match(/qqbrowser\/([\d.]+)/)[1]
                    : _version;
                // return 'QQ_' + _version;
                return true;
            }

            //QZONEJSSDK/6.7.2.1 QQJSSDK/1.2 Mozilla/5.0 (iPhone; CPU iPhone OS 9_3_2 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Mobile/13F69 Qzone/V1_IPH_QZ_6.7.2_1_APP_A NewVersion
            // if (browser.qzone) {
            //     //诡异的ua
            //     _version = userAgent.match(/qz_([\d.]+)/i) ? userAgent.match(/qz_([\d.]+)/i)[1] : _version;
            //     return 'QZONE_' + _version;
            // }

            // if (browser.wx) {
            //     _version = userAgent.match(/micromessenger\/([\d.]+)/)
            //         ? userAgent.match(/micromessenger\/([\d.]+)/)[1]
            //         : _version;
            //     return 'WX_' + _version;
            // }

            // if (browser.bat) {
            //     _version = userAgent.match(/baidubrowser\/([\d.]+)/)
            //         ? userAgent.match(/baidubrowser\/([\d.]+)/)[1]
            //         : _version;
            //     // return 'BAT_' + _version;
            //     return true;
            // }

            // ios          baiduboxapp/0_7.0.5.7_enohpi_6311_046
            // android      baiduboxapp/7.5.1
            // if (browser.batapp) {
            //     _version = userAgent.match(/baiduboxapp\/([\d._]+)/)
            //         ? userAgent.match(/baiduboxapp\/([\d._]+)/)[1]
            //         : _version;
            //     if (_version.indexOf('_') > -1) {
            //         _version = _version.split('_')[1];
            //     }
            //     return 'BATAPP_' + _version;
            // }

            // if (browser.sg) {
            //     _version = userAgent.match(/sogoumobilebrowser\/([\d.]+)/i)
            //         ? userAgent.match(/sogoumobilebrowser\/([\d.]+)/i)[1]
            //         : _version;
            //     return 'SG_' + _version;
            // }

            if (browser.firefox) {
                // return 'FF_' + _version;
                return true;
            }

            if (browser.opera) {
                // return 'OP_' + _version;
                return true;
            }

            //ios CriOs/52.0.14.258
            if (browser.chrome) {
                _version = userAgent.match(/(?:chrome|crios|crmo)\/([0-9.]+)/)
                    ? userAgent.match(/(?:chrome|crios|crmo)\/([0-9.]+)/)[1]
                    : _version;
                if (/bidubrowser/.test(userAgent) || /se 2.+x/.test(userAgent)) {
                    // 搜狗和百度暂时不支持
                    return false;
                }
                // return 'CM_' + _version;
                return true;
            }

            if (browser.safari) {
                if (userAgent.match(/android/)) {
                    // return 'WK_' + userAgent.match(/webkit\/([\d.]+)/)[1];
                    return false;
                } else {
                    try {
                        if (userAgent.match(/(?:version)[\/: ]([\d.]+)/)) {
                            _version = userAgent.match(/(?:version)[\/: ]([\d.]+)/)[1];
                        }
                    } catch (exs) {}

                    // return 'SF_' + _version;
                    return true;
                }
            }

            // if (browser.ie) {
            //     if (userAgent.indexOf('rv:11') > -1) {
            //         _version = '11';
            //     }

            //     return 'IE_' + _version;
            // }

            if (browser.edge) {
                return true;
            }
        } catch (ex) {
            return false;
        }

        return false;
    }
    /**
     * 获取设备类型
     */
    getDevice() {
        let device = { type: 'pc' };
        let win = window;
        let detect = function(ua) {
            // 一大批基于ua进行判断的正则。
            let oTemp = {};
            let os = (oTemp.os = {});
            let browser = (oTemp.browser = {});
            let webkit = ua.match(/WebKit\/([\d.]+)/);
            let android = ua.match(/(Android)\s+([\d.]+)/);
            let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
            let iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
            let webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
            let touchpad = webos && ua.match(/TouchPad/);
            let kindle = ua.match(/Kindle\/([\d.]+)/);
            let silk = ua.match(/Silk\/([\d._]+)/);
            let blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
            let bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
            let rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
            let playbook = ua.match(/PlayBook/);
            let chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
            let firefox = ua.match(/Firefox\/([\d.]+)/);
            let bIsWM = ua.match(/Windows Phone/);

            // Todo: clean this up with a better OS/browser seperation:
            // - discern (more) between multiple browsers on android
            // - decide if kindle fire in silk mode is android or not
            // - Firefox on Android doesn't specify the Android version
            // - possibly devide in os, device and browser hashes

            browser.webkit = !!webkit;

            if (browser.webkit) {
                browser.version = webkit[1];
            }

            // 是否是windows phone
            if (bIsWM) {
                os.wphone = true;
            }

            if (android) {
                os.android = true;
                os.version = android[2];
            }

            if (iphone) {
                os.ios = true;
                os.iphone = true;
                os.version = iphone[2].replace(/_/g, '.');
            }

            if (ipad) {
                os.ios = true;
                os.ipad = true;
                os.version = ipad[2].replace(/_/g, '.');
            }

            if (webos) {
                os.webos = true;
                os.version = webos[2];
            }

            if (touchpad) {
                os.touchpad = true;
            }

            if (blackberry) {
                os.blackberry = true;
                os.version = blackberry[2];
            }

            if (bb10) {
                os.bb10 = true;
                os.version = bb10[2];
            }

            if (rimtabletos) {
                os.rimtabletos = true;
                os.version = rimtabletos[2];
            }

            if (playbook) {
                browser.playbook = true;
            }

            if (kindle) {
                os.kindle = true;
                os.version = kindle[1];
            }

            if (silk) {
                browser.silk = true;
                browser.version = silk[1];
            }

            if (!silk && os.android && ua.match(/Kindle Fire/)) {
                browser.silk = true;
            }

            if (chrome) {
                browser.chrome = true;
                browser.version = chrome[1];
            }

            if (firefox) {
                browser.firefox = true;
                browser.version = firefox[1];
            }

            os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) || (firefox && ua.match(/Tablet/)));
            os.phone = !!(
                (!os.tablet &&
                    (android ||
                        iphone ||
                        webos ||
                        blackberry ||
                        bb10 ||
                        (chrome && ua.match(/Android/)) ||
                        (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
                        (firefox && ua.match(/Mobile/)))) ||
                bIsWM
            );

            return oTemp;
        };

        let deviceConfig = detect(navigator.userAgent);
        device.config = deviceConfig;

        if (deviceConfig.os.tablet) {
            device.type = 'pad';
        }

        if (/* weighing === 2 || */ deviceConfig.os.phone) {
            device.type = 'mobile';
        }

        let screenW = win.screen.width;
        let screenH = win.screen.height;
        let innerW = win.innerWidth;
        let innerH = win.innerHeight;

        // 获取设备的宽度和高度，
        // 在安卓设备中，device-width和device-height无法准确获取，
        // 这里使用通过一个取巧的方式来通过计算点密度反推设备宽高，
        // 不过这里还是不能证明能够获取正确的设备宽高。
        if (deviceConfig.os.ios || device.type === 'pc') {
            device.width = screenW;
            device.height = screenH;
        } else {
            let ratioW = screenW / innerW;
            let ratioH = screenH / innerH;
            let ratio = ratioW < ratioH ? ratioW : ratioH;
            device.width = Math.floor(screenW / ratio);
            device.height = Math.floor(screenH / ratio);
        }

        // doc.title = device.type + ":" + device.width + ":" + device.height;
        return device;
    }
}
export default BrowserInfo;



// WEBPACK FOOTER //
// ./components/f.component.mediasource/app/modules/getBrowser.js